import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { technologyPage } from '../../data/mock';
import { Cpu } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const Technology = () => {
  const { language } = useLanguage();
  const content = technologyPage[language];

  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a2a3a]/85" />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center px-4 sm:px-6 pt-24 sm:pt-32 pb-20 sm:pb-24">
        <AnimateOnScroll animation="fadeIn">
          <div className="mb-6 sm:mb-8">
            <Cpu className="text-[#3eb8b3]" size={48} strokeWidth={1} />
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={100}>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-light mb-6 sm:mb-8 text-center">
            {content.title}
          </h1>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/70 text-base sm:text-lg text-center max-w-4xl mb-12 sm:mb-16 leading-relaxed">
            {content.intro}
          </p>
        </AnimateOnScroll>

        <Link
          to="/contacto"
          className="bg-[#3eb8b3] text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg tracking-wider hover:bg-[#2ea09b] transition-colors hover-glow"
        >
          {content.cta}
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Technology;
